"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.library.empty': '暂无帖子',
    'socialMediaPlan.library.emptyDesc': '创建您的第一篇帖子。',
    'socialMediaPlan.library.contains_errors': '该帖子包含发布错误',
};
